module.exports = __webpack_public_path__ + "static/Ecolyze-872585f4f54c4f27f23dd5d701482fda.jpg";